import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("ct_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export function fileUrl(path) {
  const t = localStorage.getItem("ct_token");
  return `${API}${path}${path.includes("?") ? "&" : "?"}token=${t}`;
}

export { API };
export default api;
